import React from "react"
import Util from "../../util/util"
import echarts from "echarts"
import Data from "../../data/car"
import { Icon } from "antd"
import "./index.less"

const COND = ["EPS", "TPMS", "SRS", "ENG", "TCU", "ESC", "ABS", "EBD"]
var data = []
var imgs = {
  东南DX7: "img/dx7.jpg",
  东南DX3: "img/dx3.jpg",
  V3菱悦: "img/v3.jpg",
  V5菱致: "img/v5.jpg",
}
const TAB = ["全部", "故障", "保养"]
const TAB_EN = ["All", "Hitch", "Maintenance"]
const ChartWidth = 800
export default class Car extends React.Component {
  constructor(props) {
    super(props)
    let scale = Util.client.width / ChartWidth
    if (Util.client.width > 600) {
      scale = 1
    }
    this.state = {
      total: data,
      car: {},
      idx: 0,
      scale: scale,
    }
    this.currentTab = 0
    Util.addEventOnResize("car", client => {
      let scale = client.width / ChartWidth
      if (client.width > 600) {
        scale = 1
      }

      this.setState({ scale })
    })
  }

  getTotal() {
    Data.list().then(res => {
      data = res
      res.forEach(car => {
        car.need_1 = car.condition && Object.keys(car.condition).length
        car.need_2 = car.basic.next - car.basic.history < 1000
      })
      res.sort((a, b) => {
        return a.id - b.id
      })
      this.setState({ total: res })
      this.renderChart()
    })
  }

  /**
   * 选择车辆
   * @param idx
   */
  selectCar(idx) {
    // this.state.idx = idx
    this.setState({ idx: idx || 0 }, () => {
      this.renderChart()
    })
  }

  componentDidMount() {
    this.getTotal()
    // this.renderChart()
  }

  /**
   * 切换tab
   * @param tab
   */
  changeTab(tab) {
    this.currentTab = tab
    let list = data
    if (tab === 1) {
      list = data.filter(d => {
        return d.need_1
      })
    } else if (tab === 2) {
      list = data.filter(d => {
        return d.need_2
      })
    }
    this.setState({ idx: 0, total: list }, () => {
      this.renderChart()
    })
  }

  componentWillUnmount() {
    this.unmount = true
    Util.destroyCharts(this.chart)
    Util.addEventOnResize("car")
  }

  /**
   * 渲染图表
   * @param data
   * @param title
   */
  renderChart() {
    let { idx, total } = this.state
    let car = total[idx] || {}
    if (!this.refs.chartCon && !this.unmount) {
      setTimeout(() => {
        this.renderChart()
      }, 100)
      return
    }
    // console.log(this)
    if (car.id) {
      var chart = (this.chart = echarts.init(this.refs.chartCon))
      chart.setOption(genCarBoardOption(car.basic))
      Util.registerChartsResize(chart)
    }
  }

  render() {
    let { onCloseModal } = this.props
    let { idx, total, scale } = this.state
    let car = total[idx] || {}
    let cons = car.condition || {}

    return (
      <div className="page page-car">
        <div className="page-inner">
          <div className="header">
            <Icon type="left" onClick={onCloseModal} />
            <div>4S</div>
          </div>
          <div className="content">
            <div className="list-wrap">
              <div className="car-tab">
                {TAB.map((t, i) => {
                  return (
                    <div
                      key={i}
                      className={i === this.currentTab ? "active" : ""}
                      onClick={() => {
                        this.changeTab(i)
                      }}
                    >
                      <span>{t}</span>
                      <br />
                      <span>{TAB_EN[i]}</span>
                    </div>
                  )
                })}
              </div>
              <div className="car-list">
                {total.map((car, i) => {
                  return (
                    <div
                      key={i}
                      className={"car-item" + (i === idx ? " active" : "")}
                      onClick={() => {
                        this.selectCar(i)
                      }}
                    >
                      {car.id} - {car.factory} - {car.name}
                      {car.need_1 ? <Icon type="tool" /> : ""}
                    </div>
                  )
                })}
              </div>
            </div>
            <div className="con-wrap">
              <div className="info-con">
                <div className="con-img">
                  <img src={imgs[car["name"]]} alt={car["name"]} />
                </div>
                <div className="con-list">
                  {COND.map((item, i) => {
                    let error = cons[item]
                    return (
                      <div
                        className={"con-item" + (error ? " error" : "")}
                        key={i}
                      >
                        {item}
                        <span className="err-tag">
                          {cons[item] ? "故障" : "正常"}
                        </span>
                      </div>
                    )
                  })}
                </div>
              </div>
              <div
                className="chart-con"
                style={{
                  // transform: `scale(${scale})` ,
                  zoom: scale,
                }}
              >
                <div className="chart" ref="chartCon" />
                <div className="chart-title">
                  <span>
                    百公里油耗（升）
                    <br />
                    fuel consumption per hundred KM (L)
                  </span>
                  <span>
                    剩余保养里程
                    <br />
                    mileage left for vehicle maintenance
                  </span>
                  <span>
                    总里程
                    <br />
                    total mileage
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

function genCarBoardOption(basic) {
  return {
    backgroundColor: "rgba(61, 93, 153, 0.3)",
    tooltip: {
      formatter: "{a} <br/>{c} {b}",
    },
    toolbox: {
      show: false,
      feature: {
        mark: { show: true },
        restore: { show: true },
        saveAsImage: { show: true },
      },
    },
    series: [
      {
        name: "剩余保养里程",
        type: "gauge",
        min: 0,
        max: 5000,
        splitNumber: 10,
        radius: "50%",
        axisLine: {
          // 坐标轴线
          lineStyle: {
            // 属性lineStyle控制线条样式
            color: [[0.2, "#ff4500"], [0.8, "#1e90ff"], [1, "lime"]],
            width: 3,
            shadowColor: "#fff", //默认透明
            shadowBlur: 10,
          },
        },
        axisLabel: {
          // 坐标轴小标记
          textStyle: {
            // 属性lineStyle控制线条样式
            fontWeight: "bolder",
            color: "#fff",
            shadowColor: "#fff", //默认透明
            shadowBlur: 10,
          },
        },
        axisTick: {
          // 坐标轴小标记
          length: 15, // 属性length控制线长
          lineStyle: {
            // 属性lineStyle控制线条样式
            color: "auto",
            shadowColor: "#fff", //默认透明
            shadowBlur: 10,
          },
        },
        splitLine: {
          // 分隔线
          length: 25, // 属性length控制线长
          lineStyle: {
            // 属性lineStyle（详见lineStyle）控制线条样式
            width: 3,
            color: "#fff",
            shadowColor: "#fff", //默认透明
            shadowBlur: 10,
          },
        },
        pointer: {
          // 分隔线
          shadowColor: "#fff", //默认透明
          shadowBlur: 5,
        },
        title: {
          textStyle: {
            // 其余属性默认使用全局文本样式，详见TEXTSTYLE
            fontWeight: "bolder",
            fontSize: 20,
            fontStyle: "italic",
            color: "#fff",
            shadowColor: "#fff", //默认透明
            shadowBlur: 10,
          },
        },
        detail: {
          backgroundColor: "rgba(30,144,255,0.8)",
          borderWidth: 1,
          borderColor: "#fff",
          shadowColor: "#fff", //默认透明
          shadowBlur: 5,
          offsetCenter: [0, "50%"], // x, y，单位px
          textStyle: {
            // 其余属性默认使用全局文本样式，详见TEXTSTYLE
            fontWeight: "bolder",
            color: "#fff",
          },
        },
        data: [{ value: basic.next - basic.history, name: "km" }],
      },
      {
        name: "百公里油耗",
        type: "gauge",
        center: ["20%", "55%"], // 默认全局居中
        min: 0,
        max: 30,
        splitNumber: 10,
        radius: "40%",
        axisLine: {
          // 坐标轴线
          lineStyle: {
            // 属性lineStyle控制线条样式
            color: [[0.1, "lime"], [0.3, "#1e90ff"], [1, "#ff4500"]],
            width: 3,
            shadowColor: "#fff", //默认透明
            shadowBlur: 10,
          },
        },
        axisLabel: {
          // 坐标轴小标记
          textStyle: {
            // 属性lineStyle控制线条样式
            fontWeight: "bolder",
            color: "#fff",
            shadowColor: "#fff", //默认透明
            shadowBlur: 10,
          },
        },
        axisTick: {
          // 坐标轴小标记
          length: 15, // 属性length控制线长
          lineStyle: {
            // 属性lineStyle控制线条样式
            color: "auto",
            shadowColor: "#fff", //默认透明
            shadowBlur: 10,
          },
        },
        splitLine: {
          // 分隔线
          length: 25, // 属性length控制线长
          lineStyle: {
            // 属性lineStyle（详见lineStyle）控制线条样式
            width: 3,
            color: "#fff",
            shadowColor: "#fff", //默认透明
            shadowBlur: 10,
          },
        },
        pointer: {
          // 分隔线
          shadowColor: "#fff", //默认透明
          shadowBlur: 5,
          width: 5,
        },
        title: {
          textStyle: {
            // 其余属性默认使用全局文本样式，详见TEXTSTYLE
            fontWeight: "bolder",
            fontSize: 20,
            fontStyle: "italic",
            color: "#fff",
            shadowColor: "#fff", //默认透明
            shadowBlur: 10,
          },
        },
        detail: {
          show: false,
        },
        data: [{ value: basic.average / 10, name: "l/km" }],
      },
      {
        name: "总里程",
        type: "gauge",
        center: ["80%", "55%"], // 默认全局居中
        min: 0,
        max: 1000000,
        splitNumber: 5,
        radius: "40%",
        axisLine: {
          // 坐标轴线
          lineStyle: {
            // 属性lineStyle控制线条样式
            color: [[0.2, "lime"], [0.6, "#1e90ff"], [1, "#ff4500"]],
            width: 3,
            shadowColor: "#fff", //默认透明
            shadowBlur: 10,
          },
        },
        axisLabel: {
          // 坐标轴小标记
          textStyle: {
            // 属性lineStyle控制线条样式
            fontWeight: "bolder",
            color: "#fff",
            shadowColor: "#fff", //默认透明
            shadowBlur: 10,
          },
        },
        axisTick: {
          // 坐标轴小标记
          length: 15, // 属性length控制线长
          lineStyle: {
            // 属性lineStyle控制线条样式
            color: "auto",
            shadowColor: "#fff", //默认透明
            shadowBlur: 10,
          },
        },
        splitLine: {
          // 分隔线
          length: 25, // 属性length控制线长
          lineStyle: {
            // 属性lineStyle（详见lineStyle）控制线条样式
            width: 3,
            color: "#fff",
            shadowColor: "#fff", //默认透明
            shadowBlur: 10,
          },
        },
        pointer: {
          // 分隔线
          shadowColor: "#fff", //默认透明
          shadowBlur: 5,
          width: 5,
        },
        title: {
          textStyle: {
            // 其余属性默认使用全局文本样式，详见TEXTSTYLE
            fontWeight: "bolder",
            fontSize: 20,
            fontStyle: "italic",
            color: "#fff",
            shadowColor: "#fff", //默认透明
            shadowBlur: 10,
          },
        },
        detail: {
          show: false,
        },
        data: [{ value: basic.history, name: "km" }],
      },
    ],
  }
}
